import { ReactComponent as CakeSvg } from '../../assets/icons/cake.svg';

export const CakeIcon: SvgIcon = (props) => {
    return <CakeSvg {...props} />;
};
